// extracted by mini-css-extract-plugin
export default {"slotsWrapper":"SlotsDetail_slotsWrapper__jgU5k","accordionItem":"SlotsDetail_accordionItem__LBaLN","wrapper":"SlotsDetail_wrapper__8pzwA"};